const isRed = (value: number) => {
  return value >= 1 && value <= 26;
};

export default isRed;
